import { noop } from 'lodash'
import React, { createContext, useContext, useState } from 'react'
import { TaskState } from 'state/tasks'

type SelectedTaskContextType = [TaskState | null, React.Dispatch<React.SetStateAction<TaskState | null>>]

const SelectedTaskContext = createContext<SelectedTaskContextType>([null, noop])

export const SelectedTaskProvider: React.FC = ({ children }) => {
    const [selectedTask, setSelectedTask] = useState<TaskState | null>(null)
    return (
        <SelectedTaskContext.Provider value={[selectedTask, setSelectedTask]}>{children}</SelectedTaskContext.Provider>
    )
}

export const useSelectedTask = (): [TaskState, React.Dispatch<React.SetStateAction<TaskState | null>>] => {
    const [selectedTask, setSelectedTask] = useContext(SelectedTaskContext)
    return [selectedTask as TaskState, setSelectedTask]
}

export const withSelectedTaskProvider = <P extends object>(Component: React.ComponentType<P> | React.FC<P>) =>
    function WithSelectedTaskProvider(props: any): React.ReactElement | null {
        return (
            <SelectedTaskProvider>
                <Component {...props} />
            </SelectedTaskProvider>
        )
    }
